import React, { useState } from 'react';
import AdminLayout from '../AdminLayout';
import NewUsersChart from './components/NewUsersChart';
import ActiveUsersChart from './components/ActiveUsersChart';
import UniqueSendersChart from './components/UniqueSendersChart';
import ReferralTrafficChart from './components/ReferralTrafficChart';
import CardsAddedChart from './components/CardsAddedChart';
import PointsInEscrowChart from './components/PointsInEscrowChart';
import CardsInTransitChart from './components/CardsInTransitChart';
import PointsCreatedChart from './components/PointsCreatedChart';
import PointsDestroyedChart from './components/PointsDestroyedChart';
import EconomicBalanceChart from './components/EconomicBalanceChart';
import EscrowRatioChart from './components/EscrowRatioChart';
import TotalPointsChart from './components/TotalPointsChart';
import PointsPerUserChart from './components/PointsPerUserChart';
import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';
import './AnalyticsPage.css';

const AnalyticsPage = () => {
  const [newUsersPeriod, setNewUsersPeriod] = useState<AnalyticsPeriod>(7);
  const [activeUsersPeriod, setActiveUsersPeriod] = useState<AnalyticsPeriod>(7);
  const [uniqueSendersPeriod, setUniqueSendersPeriod] = useState<AnalyticsPeriod>(7);
  const [referralTrafficPeriod, setReferralTrafficPeriod] = useState<AnalyticsPeriod>(7);
  const [cardsAddedPeriod, setCardsAddedPeriod] = useState<AnalyticsPeriod>(7);
  const [escrowPeriod, setEscrowPeriod] = useState<AnalyticsPeriod>(7);
  const [transitPeriod, setTransitPeriod] = useState<AnalyticsPeriod>(7);
  const [pointsCreatedPeriod, setPointsCreatedPeriod] = useState<AnalyticsPeriod>(7);
  const [pointsDestroyedPeriod, setPointsDestroyedPeriod] = useState<AnalyticsPeriod>(7);
  const [economicBalancePeriod, setEconomicBalancePeriod] = useState<AnalyticsPeriod>(7);
  const [escrowRatioPeriod, setEscrowRatioPeriod] = useState<AnalyticsPeriod>(7);
  const [totalPointsPeriod, setTotalPointsPeriod] = useState<AnalyticsPeriod>(7);
  const [pointsPerUserPeriod, setPointsPerUserPeriod] = useState<AnalyticsPeriod>(7);

  return (
    <AdminLayout title="Admin - Analytics" currentPath="/admin/dashboard">
      <div className="analytics-page">
        <div className="analytics-content">
          <h1 className="analytics-title">Admin - Analytics</h1>

          <div className="analytics-charts-grid">
            <EconomicBalanceChart
              period={economicBalancePeriod}
              onPeriodChange={setEconomicBalancePeriod}
            />
            <EscrowRatioChart
              period={escrowRatioPeriod}
              onPeriodChange={setEscrowRatioPeriod}
            />
            <TotalPointsChart
              period={totalPointsPeriod}
              onPeriodChange={setTotalPointsPeriod}
            />
            <PointsPerUserChart
              period={pointsPerUserPeriod}
              onPeriodChange={setPointsPerUserPeriod}
            />
            <NewUsersChart
              period={newUsersPeriod}
              onPeriodChange={setNewUsersPeriod}
            />
            <UniqueSendersChart
              period={uniqueSendersPeriod}
              onPeriodChange={setUniqueSendersPeriod}
            />
            <ActiveUsersChart
              period={activeUsersPeriod}
              onPeriodChange={setActiveUsersPeriod}
            />
            <ReferralTrafficChart
              period={referralTrafficPeriod}
              onPeriodChange={setReferralTrafficPeriod}
            />
            <PointsInEscrowChart
              period={escrowPeriod}
              onPeriodChange={setEscrowPeriod}
            />
            <CardsInTransitChart
              period={transitPeriod}
              onPeriodChange={setTransitPeriod}
            />
            <PointsCreatedChart
              period={pointsCreatedPeriod}
              onPeriodChange={setPointsCreatedPeriod}
            />
            <PointsDestroyedChart
              period={pointsDestroyedPeriod}
              onPeriodChange={setPointsDestroyedPeriod}
            />
            <CardsAddedChart
              period={cardsAddedPeriod}
              onPeriodChange={setCardsAddedPeriod}
            />
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AnalyticsPage;
